import { orderPoStyles } from "@insite/content-library/Widgets/OrderDetails/OrderPo";
import { css } from "styled-components";


orderPoStyles!.titleText!.variant= "h3";
orderPoStyles!.titleText!.css= css`
@media print {
    font-size: 12px;
}
margin-bottom: 5px;
font-size: 16px;
`;